<template>
<div class="chapter">
<div class="inner_page">
<div id="List_of_Maps">
<p class="fm-title"><a id="page_vii"><b>List of Maps</b></a></p><a id="page_vii">
</a><p class="img-para"><a id="page_vii"></a><span href="#/xhtml/12_Chapter02#map_1" title="Link target outside of Sample">Pomerania.</span></p>
<p class="img-para"><span href="#/xhtml/17_Chapter07#map_2" title="Link target outside of Sample">Indochina.</span></p>
<p class="img-para"><span href="#/xhtml/17_Chapter07#map_3" title="Link target outside of Sample">Fortification map by Paul.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_List_of_Maps.vue?7797a828